import {HTTP} from '@/CallAPI'
export default {
  getListChecklistItem (page = '', per_page = '', status = '', search = '', sort = '', groupchkitem_id = '') {
    return HTTP.get('checklist-items', {
      params: {
        page,
        per_page,
        status,
        search,
        sort,
        groupchkitem_id
      }
    })
  },

  createChecklistItem (checklist_item = {}) {
    return HTTP.post('checklist-items', checklist_item)
  },

  showChecklistItem (checklist_item = {}) {
    return HTTP.get('checklist-items/' + checklist_item.id)
  },

  updateChecklistItem (checklist_item = {}) {
    return HTTP.put('checklist-items/' + checklist_item.id, checklist_item)
  },

  destroyChecklistItem (checklist_item = {}) {
    return HTTP.delete('checklist-items/' + checklist_item.id)
  },

  approvalChecklistItem (checklist_item = {}) {
    return HTTP.post('checklist-items/' + checklist_item.id + '/approval')
  },

  rejectChecklistItem (checklist_item = {}) {
    return HTTP.post('checklist-items/' + checklist_item.id + '/rejection')
  },

  uploadImage (image) {
    return HTTP.post('checklist-items/upload-images', image)
  },
  getReferDocument (checklist_item = {}) {
    return HTTP.get('checklist-items/' + checklist_item.id + '/refer')
  },

  multiDestroyChecklistItem (ids) {
    return HTTP.delete('multi-destroy-checklist-items', {params: {
      ids: ids
    }})
  },

  multiApprovalChecklistItem (ids) {
    return HTTP.put('multi-approval-checklist-items', {
      ids: ids
    })
  },

  multiRejectChecklistItem (ids) {
    return HTTP.put('multi-rejection-checklist-items', {
      ids: ids
    })
  },

  getHeaderChecklistItem (groupchkitem) {
    return HTTP.get('get-header-checklist-item', {params: {
      groupchkitem_id: groupchkitem.id
    }})
  }
}



// WEBPACK FOOTER //
// ./src/service/checklist-item.js